import React from "react";
import EtfDailyDataViewer from "../components/EtfDailyDataViewer";

export default function UserHome() {
  return (
    <EtfDailyDataViewer
      title="ETF Daily Market Data"
      subtitle="By default, today is shown if available. You can pick any available date for each ETF symbol."
    />
  );
}
